import { ReduxHelper } from "helpers";
import {
  IDownloadAllInprocessCheck,
  IDownloadCartonQRCodeBank,
  IDownloadExcelRequest,
  IDownloadInprocessCheck,
  IDownloadLocationListConfirmPeriodicCycleCountRequest,
  IDownloadLODeliveryProgressRequest,
  IDownloadMaterialRequisitionDetailReportRequest,
  IDownloadMaterialRequisitionReportRequest,
  IDownloadPalletMasterDataRequest,
  IDownloadProductionPlanDetailRequest,
  IDownloadProductionPlanRequest,
  IDownloadProductMasterDataRequest,
  IDownloadQRCodeBankRequest,
  IDownloadReceiveExportPalletLabel,
  IDownloadReturnReport,
  IDownloadTrackingQRCodeRequest,
  IDownloadZoneDetailRequest,
} from "model";

export const prefix = "DOWNLOAD";

export const downloadVNUserGuide =
  ReduxHelper.generateActions<IDownloadExcelRequest>(
    prefix,
    "DOWNLOAD_VN_USER_GUIDE"
  );

export const downloadENUserGuide =
  ReduxHelper.generateActions<IDownloadExcelRequest>(
    prefix,
    "DOWNLOAD_EN_USER_GUIDE"
  );

export const downloadProductMasterData = ReduxHelper.generateActions<
  IDownloadProductMasterDataRequest,
  undefined
>(prefix, "DOWNLOAD_PRODUCT_MASTER_DATA");

export const downloadWarehouseMasterData = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_WAREHOUSE_MASTER_DATA");

export const downloadZoneMasterData = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_ZONE_MASTER_DATA");

export const downloadZoneDetailMasterData = ReduxHelper.generateActions<
  IDownloadZoneDetailRequest,
  undefined
>(prefix, "DOWNLOAD_ZONE_DETAIL_MASTER_DATA");

export const downloadPalletMasterData = ReduxHelper.generateActions<
  IDownloadPalletMasterDataRequest,
  undefined
>(prefix, "DOWNLOAD_PALLET_MASTER_DATA");

export const downloadCompanyMasterData = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_COMPANY_MASTER_DATA");

export const downloadUserMasterData = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_USER_MASTER_DATA");

export const downloadProductionPlan = ReduxHelper.generateActions<
  IDownloadProductionPlanRequest,
  undefined
>(prefix, "DOWNLOAD_PRODUCTION_PLAN");

export const downloadProductionPlanDetail = ReduxHelper.generateActions<
  IDownloadProductionPlanDetailRequest,
  undefined
>(prefix, "DOWNLOAD_PRODUCTION_PLAN_DETAIL");

export const downloadProductionPlanForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_PRODUCTION_PLAN_FORM");

export const downloadReceiveDocument = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_RECEIVE_DOCUMENT");

export const downloadReceiveDocumentById = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_RECEIVE_DOCUMENT_BY_ID");

export const downloadReceiveExportPalletLabel = ReduxHelper.generateActions<
  IDownloadReceiveExportPalletLabel,
  undefined
>(prefix, "DOWNLOAD_RECEIVE_EXPORT_PALLET_LABEL");

export const downloadReceiveForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_RECEIVE_FORM");

export const downloadLODocument = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_LO_DOCUMENT");

export const downloadLODocumentForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_LO_DOCUMENT_FORM");

export const downloadLODocumentById = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_LO_DOCUMENT_BY_ID");

export const downloadLODeliveryProgress = ReduxHelper.generateActions<
  IDownloadLODeliveryProgressRequest,
  undefined
>(prefix, "DOWNLOAD_LO_DELIVERY_PROGRESS");

export const downloadAuditTrail = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_AUDIT_TRAIL");

export const downloadQRCodeTracking = ReduxHelper.generateActions<
  IDownloadTrackingQRCodeRequest,
  undefined
>(prefix, "DOWNLOAD_QR_CODE_TRACKING");

export const downloadQRCodeBankXlsx = ReduxHelper.generateActions<
  IDownloadQRCodeBankRequest,
  undefined
>(prefix, "DOWNLOAD_QR_CODE_BANK_XLSX");

export const downloadQRCodeBankCsv = ReduxHelper.generateActions<
  IDownloadQRCodeBankRequest,
  undefined
>(prefix, "DOWNLOAD_QR_CODE_BANK_CSV");

export const downloadWarehouseReport = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_WAREHOUSE_REPORT");

export const downloadPackingReport = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_PACKING_REPORT");

export const downloadForkliftPerformanceReport = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_FORKLIFT_PERFORMANCE_REPORT");

export const downloadInventoryComparisonForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_INVENTORY_COMPARISON_FORM");

export const downloadInventoryComparisonReport = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_INVENTORY_COMPARISON_REPORT");

export const downloadDeliveryHistoryReport = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_DELIVERY_HISTORY_REPORT");

export const downloadDeliveryHistoryForMarketingReport =
  ReduxHelper.generateActions<IDownloadExcelRequest, undefined>(
    prefix,
    "DOWNLOAD_DELIVERY_HISTORY_FOR_MARKETING_REPORT"
  );

export const downloadMaterialRequisitionForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_MATERIAL_REQUISITION_FORM");

export const downloadMaterialMovementForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_MATERIAL_MOVEMENT_FORM");

export const downloadPackagingMovementForm = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "DOWNLOAD_PACKAGING_MOVEMENT_FORM");

export const downloadPeriodicCycleCountProductForm =
  ReduxHelper.generateActions<IDownloadExcelRequest, undefined>(
    prefix,
    "URL_DOWNLOAD_PERIODIC_CYCLE_COUNT_PRODUCT_FORM"
  );

export const downloadPeriodicCycleCountLocationForm =
  ReduxHelper.generateActions<IDownloadExcelRequest, undefined>(
    prefix,
    "URL_DOWNLOAD_PERIODIC_CYCLE_COUNT_LOCATION_FORM"
  );
export const downloadLocationListConfirmPeriodicCycleCount =
  ReduxHelper.generateActions<
    IDownloadLocationListConfirmPeriodicCycleCountRequest,
    undefined
  >(prefix, "URL_DOWNLOAD_LOCATION_LIST_CONFIRM_PERIODIC_CYCLE_COUNT");

export const downloadLocationListPeriodicCycleCount =
  ReduxHelper.generateActions<
    IDownloadLocationListConfirmPeriodicCycleCountRequest,
    undefined
  >(prefix, "URL_DOWNLOAD_LOCATION_LIST_PERIODIC_CYCLE_COUNT");

export const downloadReturnReport = ReduxHelper.generateActions<
  IDownloadReturnReport,
  undefined
>(prefix, "URL_DOWNLOAD_RETURN_REPORT");

export const downloadMaterialRequisitionReportRequest =
  ReduxHelper.generateActions<
    IDownloadMaterialRequisitionReportRequest,
    undefined
  >(prefix, "URL_DOWNLOAD_MATERIAL_REQUISITION_REPORT");

export const downloadMaterialRequisitionDetailReportRequest =
  ReduxHelper.generateActions<
    IDownloadMaterialRequisitionDetailReportRequest,
    undefined
  >(prefix, "URL_DOWNLOAD_MATERIAL_REQUISITION_DETAIL_REPORT");

export const downloadCartonQRCodeBank = ReduxHelper.generateActions<
  IDownloadCartonQRCodeBank,
  undefined
>(prefix, "URL_DOWNLOAD_CARTON_QR_CODE_BANK");

export const downloadCycleCountQACollect = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "URL_DOWNLOAD_CYCLE_COUNT_QA_COLLECT");

export const downloadRequestMaterialDetail = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "URL_DOWNLOAD_REQUEST_MATERIAL_DETAIL");

export const downloadStockMovement = ReduxHelper.generateActions<
  IDownloadExcelRequest,
  undefined
>(prefix, "URL_DOWNLOAD_STOCK_MOVEMENT");

export const downloadInprocessCheck = ReduxHelper.generateActions<
  IDownloadInprocessCheck,
  undefined
>(prefix, "URL_DOWNLOAD_INPROCESS_CHECK");
export const downloadAllInprocessCheck = ReduxHelper.generateActions<
  IDownloadAllInprocessCheck,
  undefined
>(prefix, "URL_DOWNLOAD_ALL_INPROCESS_CHECK");
